import NotificationsListRow from './notifications-list-row'

export default NotificationsListRow
